import { cx } from '@emotion/css';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

import Icon from '../Icon';

import {
  iconClassName,
  innerClassName,
  labelClassName,
  statusClassName,
} from './styles';

interface Props {
  className?: string;
  label: string;
  indicator?: boolean;
}

const Status = ({ className, label, indicator }: Props) => {
  return (
    <div className={cx(statusClassName, className)}>
      <div className={innerClassName}>
        {indicator && <Icon className={iconClassName} fa={faCircle} />}
        <span className={labelClassName}>{label}</span>
      </div>
    </div>
  );
};

Status.displayName = 'Status';

export default Status;
